<!-- start banner Area -->

<section class="section-hero overlay inner-page bg-image" style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                                  background-size: cover;" id="home-section">
  <div class="container" style="padding: 100px 0px 100px 0px;">
    <div class="row">
      <div class="col-md-7">
        <h1 class="text-white font-weight-bold" style="    font-size: 2.5rem !important;">{{ job.getLibelle() }}</h1>
        <div class="custom-breadcrumbs">
          <a style=" color: #FF5A00 " href="/">Accueil</a> <span class="mx-2 slash">/</span>
          <a style=" color: #FF5A00 " routerLink="/job-list">Offres d'emploi</a> <span class="mx-2 slash">/</span>
          <span class="text-white"><strong>{{ job.getLibelle() }}</strong></span>
        </div>
      </div>
    </div>
  </div>
</section>


<section class="container mt-5">
  <div class="row align-items-center mb-5">
    <div class="col-lg-8 mb-4 mb-lg-0">
      <div class="d-flex align-items-center">
        <div class="border p-2 d-inline-block mr-3 rounded">
          <img *ngIf="job.getCompany()['logo']" src="{{baseURL +job.getCompany()['logo']}}" width="110"
            style="height: 90%;" alt="Logo">
          <img *ngIf="!job.getCompany()['logo'] " src="assets/img/default-logo.svg" width="110" style="height: 90%;"
            alt="Logo">
        </div>
        <div>
          <h2 style="font-weight: bold; color: #00027d;font-size: 2rem !important;">{{ job.getLibelle() }}</h2>
          <div class="mb-2">
            <span class="ml-0 mr-2 mb-2"><span class="icon-briefcase mr-2"></span>{{
              job.getCompany()['acronym']
              }}</span>
            <span class="m-2"><span class="icon-room mr-2"></span><img src="assets/img/lieu.svg">{{
              job.getCity() }}, {{ job.getCountry() }}</span>
            <span class="m-2"><span class="icon-clock-o mr-2"></span><span class="">{{ job.getTypeJob()
                }}</span></span>
          </div>
          <h2 style="font-weight: bold; color: #00027d;font-size: 1rem !important;"> Niveau du processus: <strong
              style="color: #FF5A00;" *ngIf="(job.getJobLevel()==1)">Collecte</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==2)">Pré selections</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==3)">Tests </strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==4)">Entretiens</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==5)">Dépôt de rapport</strong>
            <strong style="color: #FF5A00;" *ngIf="(job.getJobLevel()==6)">Cloture</strong>
          </h2>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="row">
        <div class="col-6">

          <a (click)="addJobInBackup(job.getId())" class=" btn btn-danger "
            style="padding: 12px 20px; color: #fff;"><span class="icon-heart-o mr-2 text-danger"></span>Sauvegarder</a>
        </div>
        <div class="col-6">
          <a class="mt-2" class="btn btn-primary" [routerLink]="['/postuler', job.getId()]"
            style="padding: 12px 20px;">Postuler</a>
        </div>
      </div>
    </div>
  </div>


  <div class="row">

    <div class="col-lg-8">
      <div class="card" style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
        <div class="card-body">
          <div class="mb-2">
            <!-- <figure class="mb-5"><img src="assets/img/offer/offre-emploi.jpg" alt="Image" class="img-fluid rounded">
            </figure> -->
            <h3 style="font-weight: bold;color: #00027d !important;font-size: 1.625rem !important"
              class="h5 d-flex align-items-center mb-4">
              <span class="icon-align-left mr-3"></span>Description de l'offre
            </h3>

            <p>{{ job.getDescription() }}</p>

          </div>
          <div class="mb-2">
            <h3 class="h5 d-flex align-items-center mb-4"
              style="font-weight: bold;color: #00027d !important;font-size: 1.625rem !important;">
              <span class="icon-book mr-3"></span>Formation + Expérience
            </h3>
            <ul>
              <li> <img src="assets/img/master.svg"> Diplômes requis
                <span *ngFor="let training of job.getJobsTrainings()"> {{
                  training.getLevelOfStudy() }} en
                  {{ training.getTraining()['libelle'] }},
                </span>
              </li>
              <li>
                <img src="assets/img/annee.svg"> <span class="lnr lnr-calendar-full"></span>
                {{ job.getYearOfExperience() }} <span
                  *ngIf="job.getYearOfExperience() != 'Sans expérience'">d'expériences</span>,
                <span class="lnr lnr-map-marker"></span>
              </li>
              <li>
                <strong class="titre">Type d'emploi:</strong> {{ job.getTypeJob() }}
              </li>
            </ul>
          </div>

          <div class="mb-2">
            <h3 class="h5 d-flex align-items-center mb-4 "
              style="font-weight: bold;color: #00027d !important;font-size: 1.625rem !important;"><span
                class="icon-turned_in mr-3"></span>Compétences
              et personnalité</h3>
            <ul>
              <li>
                <span class="titre">Langue:</span> <span class="lnr lnr-earth"></span> <span
                  *ngFor="let language of job.getJobsLanguages()">
                  {{ language.getLanguage()['libelle'] }}, </span>
              </li>
              <li>
                <span class="titre">Compétence requise:</span> <span class="lnr lnr-book"></span> <span
                  *ngIf="job.getJobsSkills().length == 0">
                  Aucune compétence spécifique</span> <span *ngFor="let skill of job.getJobsSkills()">
                  {{ skill.getSkill()['libelle'] }}, </span>
              </li>

            </ul>
            <p><a href="{{
                  baseURL +job.getCompany()['job_describe_file'] }}"
                style="font-weight: bold; color: #FF5A00 ;font-size: 1rem;">Voir plus sur l'avis </a></p>
          </div>

          <div class="row mb-5">
            <div class="col-6">
              <a (click)="addJobInBackup(job.getId())" style="color: white;"
                class="btn btn-block btn-danger btn-md"><span
                  class="icon-heart-o mr-2 text-danger"></span>Sauvegarder</a>
            </div>
            <div class="col-6">
              <a [routerLink]="['/postuler', job.getId()]" class="btn btn-block btn-primary btn-md">Postuler maintenant
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">


      <div class="bg-light p-3 border rounded mb-4">
        <h3 class="mt-3 h5 pl-3 mb-3 " style="font-weight: bold; color: #00027d;font-size: 1.625rem;">
          Infromations sur l'offre</h3>
        <ul class="list-unstyled pl-3 mb-0">
          <li class="mb-2"><strong class="text-black">Type d'emploi :</strong> {{ job.getTypeJob()
            }}</li>
          <li class="mb-2"><strong class="text-black">Année d'Expérience :</strong> {{ job.getYearOfExperience() }}
            <span *ngIf="job.getYearOfExperience() != 'Sans expérience'"></span>,
            <span class="lnr lnr-map-marker"></span>
          </li>
          <li class="mb-2"><strong class="text-black">Adresse :</strong> {{
            job.getCity() }}, {{ job.getCountry() }}</li>
          <li class="mb-2"><strong class="text-black">Date limite :</strong>{{ job.getExpirationDate()
            }}</li>
        </ul>
      </div>

      <div class="bg-light p-3 border rounded" style="">
        <h3 class="  mt-3 h5  mb-3 " style="font-weight: bold; color: #00027d;font-size: 1.625rem;">Partager l'avis</h3>
        <div class="social-share mt-2">
          <a target="_blank" href="https://www.facebook.com/talentsplusafrique" style="margin-right: 10px"><img
              src="assets/img/facebook1.svg" width="20"></a>
          <a target="_blank" href="https://www.linkedin.com/in/talents-plus-groupe-b325887a/"
            style="margin-right: 10px"><img src="assets/img/linkedin1.svg" width="20"></a>
          <a target="_blank" href="https://twitter.com/TalentsPlus"><img src="assets/img/twitter1.svg" width="20"></a>
        </div>
      </div>
      <br>
      <img width="100%" src="assets/img/ban-pub.jpg">

    </div>
  </div>
</section>

<br><br>
<!-- Start service Area -->
<!-- <section class="container">
  <div class="details">
    <div class="side-left">
      <div data-testid="job-summary-section-organization" class="sc-17gqtt5-0 emWsbY">
        <h4 style="font-size: 0.6875rem !important;" class="sc-17gqtt5-2 Jfzsf"><span>L'entreprise</span></h4><a
          data-testid="job-header-organization-link-logo" class="sc-19vdx99-0 ezBbTx" style="    margin-top: -40px;">
          <div size="30" class="sc-19vdx99-1 iuiJPo">
          </div>
          <h4 data-testid="job-summary-organization-title" class="sc-17gqtt5-6 fmXfcH">{{ job.getCompany()['acronym'] }}
          </h4>
        </a>
        <div class="" style="">
          <img src="{{baseURL +job.getCompany()['logo']}}" width="110" style="height: 90%;" alt="">
        </div>
        <div>
          <p>{{ job.getCompany()['nb_person']
            }} salariés</p>
        </div>
        <div data-testid="job-summary-section-job" class="sc-17gqtt5-0 emWsbY">
          <h4 style="font-size: 0.6875rem !important;" class="sc-17gqtt5-2 Jfzsf"><span>Le poste</span></h4>
          <h4 data-testid="job-summary-job-title" class="sc-17gqtt5-7 ZfceX">{{ job.getLibelle() }}</h4>
          <p style="    font-size: 0.875rem;"><a color="dark.200" rel="noopener noreferrer" target="_blank"
              display="inline" font-weight="400" class="sc-Dmqmp iIolbJ sc-dxtBLK krLavW"><span class="wui-text"><img
                  src="assets/img/lieu.svg"> {{
                job.getCity() }}, {{ job.getCountry() }}</span></a></p>
          <p style="    font-size: 0.875rem;"><span>Éducation : </span><span
              *ngFor="let training of job.getJobsTrainings()">{{
              training.getLevelOfStudy() }} en
              {{ training.getTraining()['libelle'] }} ou</span></p>
          <p style="font-size: 0.875rem;"><span>Expérience :
            </span><span>&gt; {{ job.getYearOfExperience() }}
              ans</span></p>
        </div>
      </div>

    </div>
    <div class="centre">
      <h2 style="color: #00027d !important; font-size: 1.625rem;">Description de l'offre</h2>
      <p class="description">{{ job.getDescription() }}</p>

      <p><strong style="font-weight: bold; color: #00027d;font-size: 1.625rem;">Contexte et expérience</strong></p>
      <ul>
        <li> <img src="assets/img/master.svg"> Diplômes requis
          <span *ngFor="let training of job.getJobsTrainings()"> {{
            training.getLevelOfStudy() }} en
            {{ training.getTraining()['libelle'] }} ou
          </span>
        </li>
        <li>
          <img src="assets/img/annee.svg"> <span class="lnr lnr-calendar-full"></span>
          {{ job.getYearOfExperience() }} <span
            *ngIf="job.getYearOfExperience() != 'Sans expérience'">d'expériences</span>, <span
            class="lnr lnr-map-marker"></span>
        </li>
        <li>
          <strong class="titre">Type d'emploi:</strong> {{ job.getTypeJob() }}
        </li>
      </ul>

      <p><strong style="font-weight: bold; color: #00027d;font-size: 1.625rem;">Compétences et personnalité</strong></p>
      <ul>
        <li>
          <span class="titre">Langue:</span> <span class="lnr lnr-earth"></span> <span
            *ngFor="let language of job.getJobsLanguages()">
            {{ language.getLanguage()['libelle'] }}, </span>
        </li>
        <li>
          <span class="titre">Compétence requise:</span> <span class="lnr lnr-book"></span> <span
            *ngIf="job.getJobsSkills().length == 0">
            Aucune compétence spécifique</span> <span *ngFor="let skill of job.getJobsSkills()">
            {{ skill.getSkill()['libelle'] }}, </span>
        </li>

      </ul>
      <p><strong style="font-weight: bold; color: #00027d;font-size: 1.625rem;">Adresse</strong></p>
      <ul>
        <li>
          <img src="assets/img/lieu.svg"> {{ job.getCity() }}, {{ job.getCountry() }}
        </li>
      </ul>

      <p><a href="{{
          baseURL +job.getCompany()['job_describe_file'] }}"
          style="font-weight: bold; color: #FF5A00 ;font-size: 1rem;">Télécharger l'offre </a></p>

      <div class="sc-cwSeag WAZcM sc-gelMue cSdAHX sc-1bj0he-0 lpnMrS">
        <div class="" style="">
          <img src="{{baseURL +job.getCompany()['logo']}}" width="30" style="height: 90%;" alt="">
        </div>

        <p color="light.100" class="sc-kIlzlo iIMYMq  wui-text">{{ job.getCompany()['acronym'] }}</p>

        <h4 class="sc-kIlzlo ewwmUQ  wui-text" style="font-weight: bold;"><span>Cette offre vous tente ?</span></h4>
        <button class=" btn btn-danger " style="margin-right: 10px;">Sauvegarder</button>
        <a class="mt-2" [routerLink]="['/postuler', job.getId()]"><button class="btn btn-primary">Postuler</button></a>

        <div class="social-share mt-2">
          <a target="_blank" href="https://www.facebook.com/talentsplusafrique" style="margin-right: 10px"><img
              src="assets/img/facebook1.svg" width="20"></a>
          <a target="_blank" href="https://www.linkedin.com/in/talents-plus-groupe-b325887a/"
            style="margin-right: 10px"><img src="assets/img/linkedin1.svg" width="20"></a>
          <a target="_blank" href="https://twitter.com/TalentsPlus"><img src="assets/img/twitter1.svg" width="20"></a>
        </div>
      </div>

    </div>
    <div class="side-right">
      <img width="100%" src="assets/img/ban-pub.jpg">
    </div>
  </div>
</section> -->